import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0};
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/dashboard'
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/assinaturas/todas',
          name: 'assinaturas-todas',
          component: () => import('./views/assinaturas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/assinaturas/:id', // Precisa ser a última roda deste nível
          name: 'assinatura-detalhes',
          component: () => import('./views/assinaturas/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/clientes/todos',
          name: 'clientes-todos',
          component: () => import('./views/clientes/Todos.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/comissao/solicitar-saque',
          name: 'comissao-solicitar-saque',
          component: () => import('./views/comissao/SolicitarSaque.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/comissao/saques-solicitados',
          name: 'comissao-saques-solicitados',
          component: () => import('./views/comissao/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/comissao/todas',
          name: 'comissao-todas',
          component: () => import('./views/comissao/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/todas',
          name: 'vendas-todas',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/ultimos-7-dias',
          name: 'vendas-ultimos-7-dias',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/mes-atual',
          name: 'vendas-mes-atual',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/mes-passado',
          name: 'vendas-mes-passado',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/ano-atual',
          name: 'vendas-ano-atual',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/boletos',
          name: 'vendas-boletos',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/cartoes',
          name: 'vendas-cartoes',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/iugu',
          name: 'vendas-iugu',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/paypal-assinaturas',
          name: 'vendas-paypal-assinaturas',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/paypal-vendas',
          name: 'vendas-paypal-vendas',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/canceladas',
          name: 'vendas-canceladas',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/transferencias',
          name: 'vendas-transferencias',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/aguardando-pagamento',
          name: 'vendas-aguardando-pagamento',
          component: () => import('./views/vendas/Todas.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/vendas/:id', // Precisa ser a última roda deste nível
          name: 'venda-detalhes',
          component: () => import('./views/vendas/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/clientes',
          name: 'clientes',
          component: () => import('./views/clientes/Todos.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/clientes/novo',
          name: 'cliente-novo',
          component: () => import('./views/clientes/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/clientes/:id',
          name: 'cliente-detalhes',
          component: () => import('./views/clientes/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/comissoes',
          name: 'comissoes',
          component: () => import('./views/comissoes/Todas.vue'),
          meta: {
            role: ['admin', 'dev']
          }
        },
        {
          path: '/comissoes/minha',
          name: 'comissoes-minha',
          component: () => import('./views/comissoes/Minha.vue'),
          meta: {
            role: ['admin', 'dev', 'supervisor']
          }
        },
        {
          path: '/user-settings',
          name: 'user-settings',
          component: () => import('@/views/pages/user-settings/Settings.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/relatorios/reconciliacao',
          name: 'relatorios-reconciliacao',
          component: () => import('./views/relatorios/Reconciliacao.vue'),
          meta: {
            role: ['admin', 'dev', 'supervisor']
          }
        },
        {
          path: '/relatorios/reconciliacao-paypal',
          name: 'relatorios-reconciliacao-paypal',
          component: () => import('./views/relatorios/ReconciliacaoPayPal.vue'),
          meta: {
            role: ['admin', 'dev', 'supervisor']
          }
        },
        {
          path: '/relatorios/reconciliacao-iugu',
          name: 'relatorios-reconciliacao-iugu',
          component: () => import('./views/relatorios/ReconciliacaoIugu.vue'),
          meta: {
            role: ['admin', 'dev', 'supervisor']
          }
        },
        {
          path: '/relatorios/reconciliacao-paypal-assinatura',
          name: 'relatorios-reconciliacao-paypal-assinatura',
          component: () => import('./views/relatorios/ReconciliacaoPayPalAssinatura.vue'),
          meta: {
            role: ['admin', 'dev', 'supervisor']
          }
        },
        {
          path: '/relatorios/devolucoes',
          name: 'relatorios-devolucoes',
          component: () => import('./views/relatorios/Devolucoes.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/relatorios/mobile',
          name: 'relatorios-mobile',
          component: () => import('./views/relatorios/Mobile.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/banners',
          name: 'banners',
          component: () => import('./views/banners/Todos.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/banner/:id?',
          name: 'banner-detalhes',
          component: () => import('./views/banners/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/videos',
          name: 'videos',
          component: () => import('./views/videos/Todos.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/video/:id?',
          name: 'video-detalhes',
          component: () => import('./views/videos/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/websitevideos',
          name: 'websitevideos',
          component: () => import('./views/websitevideos/Todos.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/websitevideo/:id?',
          name: 'websitevideo-detalhes',
          component: () => import('./views/websitevideos/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/planos',
          name: 'planos',
          component: () => import('./views/planos/Todos.vue'),
          meta: {
            role: ['admin', 'dev', 'supervisor']
          }
        },
        {
          path: '/plano/:id?',
          name: 'plano-detalhes',
          component: () => import('./views/planos/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev', 'supervisor']
          }
        },
        {
          path: '/usuarios',
          name: 'usuarios',
          component: () => import('./views/usuarios/Todos.vue'),
          meta: {
            role: ['admin', 'dev']
          }
        },
        {
          path: '/usuario/:id?',
          name: 'usuario-detalhes',
          component: () => import('./views/usuarios/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev']
          }
        },
        {
          path: '/coupons',
          name: 'coupons',
          component: () => import('./views/coupon/Todos.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/coupon/:id?',
          name: 'coupon-detalhes',
          component: () => import('./views/coupon/Detalhes.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/pages/logout',
          name: 'page-logout',
          component: () => import('@/views/pages/login/Logout.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/Register.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            role: ['admin', 'dev', 'atendente', 'supervisor']
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
});

router.beforeEach((to, from, next) => {
  let user = {};
  if (localStorage.getItem('user') !== 'undefined') {
    try {
      user = JSON.parse(localStorage.getItem('user')) || {};
    } catch (error) {
    // eslint-disable-next-line
    }
  }

  if (to.name !== 'page-login' && to.name !== 'page-logout' && to.name !== 'page-register' && !user.access_token) {
    next({name: 'page-login'});
  } else {
    next();
  }
});

router.afterEach(() => {
  // Remove initial loadings
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
